import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { SidebarService } from "../sidebar/sidebar.service";
import { RequestService } from '../../../services/request.service';
import * as $ from 'jquery';

@Component({
    selector: 'app-sidebar',
    templateUrl:'./sidebar.component.html',
})

export class SidebarComponent implements OnInit {

    searchText: String;
    menuItems: any[] = [];
    filteredMenuItems: any[] = [];

    moduleDetails = [];
    subMenuMap = new Map();
    employeeId;
    subModuleAction = [];

    constructor(
        public sidebarservice: SidebarService,
        private router: Router,
        private request: RequestService
    ) {

        router.events.subscribe((event: Event) => {

            if (event instanceof NavigationStart) {
            }

            if (event instanceof NavigationEnd && $(window).width() < 1025 && (document.readyState == 'complete' || false)) {
                this.toggleSidebar();
            }

            if (event instanceof NavigationError) {
                console.log(event.error);
            }
        });

    }
    

    onSearchMenu(): void {

        const search = (this.searchText || '')
            .trim()
            .toLowerCase();

        // Search box empty
        if (!search) {
            this.filteredMenuItems = this.menuItems;
            return;
        }

        // Search all levels
        this.filteredMenuItems = this.menuItems
        .map((menuItem: any) => {
            return this.filterMenuItem(menuItem, search);
        })
        .filter((menuItem: any) => menuItem !== null);
    }


    filterMenuItem(menuItem: any, search: string): any {

        // Check current module title
        const titleMatch =
            !!menuItem.title &&
            menuItem.title
            .toString()
            .toLowerCase()
            .includes(search);
        let filteredSubmenu: any[] = [];


        // Search submenu recursively
        if (
            menuItem.submenu &&
            menuItem.submenu.length > 0
        ) {

            filteredSubmenu = menuItem.submenu
            .map((subItem: any) => {
                return this.filterMenuItem(
                    subItem,
                    search
                );
            })
            .filter((item: any) => item !== null);
        }

        if (
            titleMatch ||
            filteredSubmenu.length > 0
        ) {

            return {
                ...menuItem,
                submenu: titleMatch
                    ? menuItem.submenu
                    : filteredSubmenu
            };
        }
        // No match
        return null;
    }

    isModuleActive(menuItem: any): boolean {

        const currentUrl = this.router.url;

        if (menuItem.path && menuItem.path === currentUrl) {
            return true;
        }

        if (!menuItem.submenu || menuItem.submenu.length === 0) {
            return false;
        }

        return menuItem.submenu.some(
            (item: any) => item.path === currentUrl
        );
    }

    isSubMenuActive(menuSubItem: any): boolean {

        return menuSubItem.path === this.router.url;
    }

    toggleSidebar() {
        this.sidebarservice.setSidebarState(!this.sidebarservice.getSidebarState());
    }

    getSideBarState() {
        return this.sidebarservice.getSidebarState();
    }

    hideSidebar() {
        this.sidebarservice.setSidebarState(true);
    }

    viewDashboard() {
        this.router.navigate(['/form/d2d-dashboard']);
    }

    ShowAndHideSidebar(type) {
        if (type == true) {
            $(".sidebar").hide();
            this.sidebarservice.setSidebarState(type);
        } else {
            $(".sidebar").show();
            this.sidebarservice.setSidebarState(type);
        }
    }

    async ngOnInit() {

        if (localStorage.getItem('email') != "" && localStorage.getItem('email') != null) {

            if (Number(localStorage.getItem('roleId')) == 0 || Number(localStorage.getItem('roleId')) == 1) {
                this.employeeId = 0;
            } else {
                this.employeeId = localStorage.getItem('employeeId');
            }

            let isSubModuleAccess = false;

            // ✅ FIX for hash based routing
            // example : #/pages/live-panel
            const hashUrl = window.location.hash || '';
            const cleanUrl = hashUrl.startsWith('#/') ? hashUrl.substring(2) : hashUrl.replace('#', '');
            const splitUrl = cleanUrl.split('/');

            // splitUrl[0] => form / pages
            // splitUrl[1] => route name

            this.moduleDetails.push({
                path: '/form/d2d-dashboard',
                title: "Dashboard",
                icon: "zmdi zmdi-chart",
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: []
            });

            try {

                const module = {
                    moduleId: 0,
                    employeeId: this.employeeId
                };

                const data: any = await this.request.post('/master/view_sidebar_menu/', module);

                let lastModuleId = 0, lastTitle = "";
                let subMenuArr = [];

                for (let objKey of Object.keys(data)) {

                    let dataObj = data[objKey];

                    if (objKey == "result") {

                        for (let objKey1 of Object.keys(dataObj)) {

                            if (dataObj[objKey1].moduleId != lastModuleId && lastModuleId != 0) {
                                if (subMenuArr.length > 0) {
                                    this.subMenuMap.set(lastModuleId, subMenuArr);
                                    subMenuArr = [];
                                }
                            }

                            this.subModuleAction.push({
                                moduleId: dataObj[objKey1].moduleId,
                                subModuleId: dataObj[objKey1].subModuleId,
                                action: dataObj[objKey1].actionAssign,
                                path: dataObj[objKey1].subPath[0],
                            });

                            localStorage.setItem("subModule", JSON.stringify(this.subModuleAction));

                            // ✅ FIXED access check (hash routing safe)
                            const apiPath = dataObj[objKey1].subPath[0].split('/')[0];

                            if (splitUrl.length > 1 && splitUrl[1] === apiPath) {
                                isSubModuleAccess = true;
                            }

                            if (dataObj[objKey1].menuStatus != "disabled") {

                                if (dataObj[objKey1].moduleId == 7) {

                                    if (
                                        dataObj[objKey1].subPath[0] == "live-panel2" ||
                                        dataObj[objKey1].subPath[0] == "live-panel" ||
                                        dataObj[objKey1].subPath[0] == "live-screen-view/0" ||
                                        dataObj[objKey1].subPath[0] == "bus-employee-location"
                                    ) {

                                        subMenuArr.push({
                                            path: "/pages/" + dataObj[objKey1].subPath[0],
                                            title: dataObj[objKey1].subTitle[0],
                                            icon: dataObj[objKey1].subIcon[0],
                                            class: '',
                                            badge: '',
                                            badgeClass: '',
                                            isExternalLink: false,
                                            submenu: []
                                        });

                                    } else {

                                        subMenuArr.push({
                                            path: "/form/" + dataObj[objKey1].subPath[0],
                                            title: dataObj[objKey1].subTitle[0],
                                            icon: dataObj[objKey1].subIcon[0],
                                            class: '',
                                            badge: '',
                                            badgeClass: '',
                                            isExternalLink: false,
                                            submenu: []
                                        });
                                    }

                                } else {

                                    subMenuArr.push({
                                        path: "/form/" + dataObj[objKey1].subPath[0],
                                        title: dataObj[objKey1].subTitle[0],
                                        icon: dataObj[objKey1].subIcon[0],
                                        class: '',
                                        badge: '',
                                        badgeClass: '',
                                        isExternalLink: false,
                                        submenu: []
                                    });
                                }

                                lastModuleId = dataObj[objKey1].moduleId;
                            }

                        }

                        this.subMenuMap.set(lastModuleId, subMenuArr);
                        subMenuArr = [];
                    }
                }

                if (Number(localStorage.getItem('roleId')) == 1) {

                    for (let objKey of Object.keys(data)) {

                        let dataObj = data[objKey];

                        if (objKey == "result") {

                            for (let objKey1 of Object.keys(dataObj)) {

                                if (dataObj[objKey1].title[0] != lastTitle) {

                                    if (dataObj[objKey1].title[0] != "Settings") {

                                        this.moduleDetails.push({
                                            path: '',
                                            title: dataObj[objKey1].title[0],
                                            icon: dataObj[objKey1].icon[0],
                                            class: 'sub',
                                            badge: '',
                                            badgeClass: '',
                                            isExternalLink: false,
                                            submenu: this.subMenuMap.get(dataObj[objKey1].moduleId)
                                        });
                                    }
                                }

                                lastTitle = dataObj[objKey1].title[0];
                            }
                        }
                    }

                } else {

                    for (let objKey of Object.keys(data)) {

                        let dataObj = data[objKey];

                        if (objKey == "result") {

                            for (let objKey1 of Object.keys(dataObj)) {

                                if (dataObj[objKey1].title[0] != lastTitle) {

                                    this.moduleDetails.push({
                                        path: '',
                                        title: dataObj[objKey1].title[0],
                                        icon: dataObj[objKey1].icon[0],
                                        class: 'sub',
                                        badge: '',
                                        badgeClass: '',
                                        isExternalLink: false,
                                        submenu: this.subMenuMap.get(dataObj[objKey1].moduleId)
                                    });
                                }

                                lastTitle = dataObj[objKey1].title[0];
                            }
                        }
                    }
                }

                this.menuItems = this.moduleDetails;
                this.filteredMenuItems = this.menuItems;

            } catch (error) {
            }

            // ✅ do not redirect when route is valid
            if (isSubModuleAccess == false && splitUrl[1] != 'd2d-dashboard') {
                this.viewDashboard();
            }

            $.getScript('./assets/js/app-sidebar.js');

        } else {
            this.router.navigate(['/auth/signin']);
        }
    }

    openMenu(item) {
        if (!item || !item.path) {
            return;
        }
        if (item.path === '/pages/live-panel' || item.path === '/pages/live-panel2') {
            const url = `${window.location.origin}/#${item.path}`;
            window.open(url, '_blank');
            return;
        }
        this.router.navigateByUrl(item.path);
    }
}
